<template>
<div>
    <b-form-select v-model="selected" @change="onChange" :options="tax_rates">
    </b-form-select>
</div>
</template>
<script>
import { mapGetters } from 'vuex';

import TaxRateService from "@/store/services/taxrate.service.js";

export default {
    name: "VatInput",
    props: ['value', 'countryCode'],
    components: {},
    data() {
        return {
            tax_rates: [],
            item: this.$props.value,
            selected: this.$props.value.vat_exempt ? 'exempt' : this.$props.value.tax_rate,
        }
    },
    computed: {
        ...mapGetters({ 
            getCompanyId: 'main/getCompanyId',
        }),
    },
    created(){
        TaxRateService.list({company_profile: this.getCompanyId}).then((response) => {
            this.tax_rates = response.data;
            this.tax_rates = this.tax_rates.sort(this._compare);
            for(var i=0;i<this.tax_rates.length;i++){
                this.tax_rates[i].text = this.tax_rates[i].taxrate+"%";
                this.tax_rates[i].value = this.tax_rates[i].taxrate;
            }
            this.tax_rates.push({value: 'exempt', text: this.$gettext("VAT exempt"), order: -1});
        });
    },
    methods: {
        onChange (value){
            if(value == 'exempt'){
                this.item.vat_exempt = true;
            }else{
                this.item.vat_exempt = false;
                this.item.tax_rate = value;
            }
            this.$emit('input', this.item);
        },
        _compare(a, b) {
            const groupA = a.taxrate;
            const groupB = b.taxrate;
            if (groupA > groupB) {
                return -1;
            } else if (groupA < groupB) {
                return 1;
            }
        },
    }
};
</script>
<style >
</style>